import { Plate } from "../../components/Plate";

import { BackgroundContainer } from "./styles";

export const Home: React.FC = () => {
  return (
    <BackgroundContainer>
      <Plate></Plate>
    </BackgroundContainer>
  );
};
